var React = require('react');

function IcAwsToolsAndSdks (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M20,0L2.68,10v20L20,40l17.32-10V10L20,0z M35.344,28.858l-14.349,8.285l0.022-5.079l-1.976,0.033\n\t\tl-0.022,5.054L4.656,28.859V12.246l4.389,2.53l1.022-1.693l-4.391-2.533L20,2.282l14.406,8.317l-4.391,2.531l0.941,1.739\n\t\tl4.389-2.53L35.344,28.858L35.344,28.858z M11.021,14.815v10.369L20,30.368l8.979-5.184V14.815L20,9.631L11.021,14.815z\n\t\t M19.061,27.544l-6.064-3.501v-6.987l6.094,3.514L19.061,27.544z M27.003,24.044l-5.967,3.445l0.03-6.915l5.936-3.423v6.894H27.003\n\t\tz M20.081,18.86l-6.059-3.494L20,11.914l6.059,3.498L20.081,18.86z"})));
}

IcAwsToolsAndSdks.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsToolsAndSdks;

IcAwsToolsAndSdks.default = IcAwsToolsAndSdks;
